"use client";
import { useAtomValue } from "jotai";
import {
  cursorAtom,
  isViewOnlyModeAtom,
  togglesAtomResettable,
} from "@zapier/canvas-state";

import { Canvas } from "../components/Canvas";
import { MultiSelectPanel } from "../components/MultiSelectPanel";
import { CanvasBackground } from "../components/CanvasBackground";
import { WhatsNewAlert } from "../components/WhatsNewAlert";

import styles from "./IframeEmbeddedCanvas.module.css";

export function CanvasById() {
  const cursorMode = useAtomValue(cursorAtom);
  const isViewOnlyMode = useAtomValue(isViewOnlyModeAtom);
  const toggles = useAtomValue(togglesAtomResettable);

  return (
    <div className={styles.wrapper}>
      {!isViewOnlyMode && toggles.show_whats_new_alert.isOn && (
        <WhatsNewAlert />
      )}
      {cursorMode !== "add-group" && !isViewOnlyMode && <MultiSelectPanel />}
      <Canvas>
        <CanvasBackground />
      </Canvas>
    </div>
  );
}
